/** Downloads UTF-8 CSV with a BOM for spreadsheet applications. */
export const downloadCsv = (filename: string, contents: string): void => {
    const blob = new Blob(['\uFEFF', contents], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    link.click()
    URL.revokeObjectURL(url)
}
